import angular from 'angular';
import moment from 'moment';
import { IAfastamento } from '../models/afastamento.model';
import { IAfastamentoMotivo } from '../models/afastamentomotivo.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { MeurhAfastamentosService } from '../afastamentos.service';
import { PersonaAfastamentos } from '../../../Persona/Afastamentos/personaafastamentos.service';

export class MeurhAfastamentosFormController {

  static $inject = [
    '$scope',
    '$rootScope',
    'ListagemService',
    'MeurhAfastamentosService',
    'PersonaAfastamentos',
    'NewToaster',
  ];

  public readonly motivosHabilitamCid: string[] = ['001', '002', '003', '004', '006', '008', '014', '035'];

  public entity: IAfastamento;
  public form: angular.IFormController;
  public tipo = '-1';
  public busy = false;
  public countFunctionDiasAfastamento = 0;
  public action: string;

  public dataAtual = moment();
  public motivos: IAfastamentoMotivo[] = [];

  public filters: {empresa?: string, estabelecimento?: string} = {};
  public empresas: Empresa[];
  public estabelecimentos: Estabelecimento[];
  public listagemPermissao = ['criar_afastamentos'];
  public permissaoGrupoEmpresarial = false;

  public motivosHabilitamAfastamentoOrigem: IAfastamentoMotivo[] = [
    {
      id: 1,
      descricao: 'Prorrogação decorrente do mesmo acidente de trabalho',
      tipohistorico: '002'
    },
    {
      id: 4,
      descricao: 'Prorrogação decorrente da mesma doença',
      tipohistorico: '004'
    },
    {
      id: 5,
      descricao: 'Prorrogação decorrente do mesmo acidente não relacionado ao trabalho',
      tipohistorico: '004'
    },
  ];

  public constructorAfastamentoOrigem;
  public constructorLookupColaborador;
  public constructorLookupMedico;

  constructor(
    public $scope: angular.IScope,
    public $rootScope: angular.IRootScopeService & {
      temPermissao: (arg: string) => boolean,
      modoGestorPermissao: (arg: string) => boolean,
      temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
      liberadoTela: (arg: string) => boolean,
      session: any,
      nsjGlobals: any,
    },
    public ListagemService: ListagemService,
    public MeurhAfastamentosService: MeurhAfastamentosService,
    public PersonaAfastamentos: PersonaAfastamentos,
    public NewToaster: { pop: Function },
  ) {
    this.filters = {
        empresa: $rootScope.session.entities.empresa.empresa,
        estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento
    };
    this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(this.listagemPermissao, this.$rootScope.nsjGlobals.a.grupoempresarial);
  }

  $onInit() {
    if (this.action !== 'update') {
      this.entity.motivo = '';
    }
    this.constructorLookupMedico = {};
    this.entity.erroDiasafastamento = undefined;

    if (this.action === 'retrieve' || this.action === 'update') {
      this.alteraEntity();
    } else {
        this.resetDatas();
    }

    this.montaListagemVisibilidade();
    this.setConstructorLookupColaborador();
  }

  montaListagemVisibilidade() {
    if (this.action === 'retrieve' || this.action === 'update') {
      this.filters.empresa = this.entity.estabelecimentoobj.empresa;
      this.filters.estabelecimento = this.entity.estabelecimentoobj.estabelecimento;
    }
    this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
    this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
  }

  mudaEstabelecimentos() {
    this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
    this.filters.estabelecimento = '';
    this.filtraEmpresaEstabelecimento();
  }

  filtraEmpresaEstabelecimento() {
     this.setConstructorLookupColaborador();
  }

  setConstructorLookupColaborador() {
    this.constructorLookupColaborador = {
      'empresa': this.filters.empresa,
      'estabelecimento': this.filters.estabelecimento,
      'status': '00',
      'forcagestor': this.$rootScope.modoGestorPermissao('criar_afastamentos'),
      ...(this.tipo && { 'tipo': this.tipo }),
    };
  }

  montaMotivos(): void {
    this.motivos = [
      {
        id: 0,
        descricao: 'Acidente de Trabalho',
        tipohistorico: '001'
      },
      {
        id: 1,
        descricao: 'Prorrogação decorrente do mesmo acidente de trabalho',
        tipohistorico: '002'
      },
      {
        id: 2,
        descricao: 'Doença',
        tipohistorico: '003'
      },
      {
        id: 3,
        descricao: 'Acidente não relacionado ao trabalho',
        tipohistorico: '003'
      },
      {
        id: 4,
        descricao: 'Prorrogação decorrente da mesma doença',
        tipohistorico: '004'
      },
      {
        id: 5,
        descricao: 'Prorrogação decorrente do mesmo acidente não relacionado ao trabalho',
        tipohistorico: '004'
      },
      {
        id: 7,
        descricao: 'Maternidade',
        tipohistorico: '006'
      },
      {
        id: 8,
        descricao: 'Maternidade de filho com microencefalia',
        tipohistorico: '033'
      },
      {
        id: 9,
        descricao: 'Maternidade por aborto expontâneo',
        tipohistorico: '008'
      },
      {
        id: 10,
        descricao: 'Serviço militar',
        tipohistorico: '009'
      },
      {
        id: 11,
        descricao: 'Licença não remunerada ou sem vencimentos',
        tipohistorico: '011'
      },
      {
        id: 12,
        descricao: 'Suspensão',
        tipohistorico: '030'
      },
      {
        id: 13,
        descricao: 'Licença remunerada',
        tipohistorico: '041'
      },
      {
        id: 14,
        descricao: 'Adoção',
        tipohistorico: '042'
      },
      {
        id: 15,
        descricao: 'Guarda judicial de criança',
        tipohistorico: '042'
      },
      {
        id: 16,
        descricao: 'Vítima de violência - Lei Maria da Penha',
        tipohistorico: '044'
      },
      {
        id: 17,
        descricao: 'Prorrogação de licença maternidade',
        tipohistorico: '050'
      },
      {
        id: 18,
        descricao: 'Qualificação - Afastamento por suspensão do contrato de acordo com o art 476-A da CLT',
        tipohistorico: '013'
      },
      {
        id: 19,
        descricao: 'Licença Maternidade - 121 dias a 180 dias, Lei 11.770/2008 (Empresa Cidadã), inclusive para o cônjuge sobrevivente',
        tipohistorico: '007'
      },
      {
        id: 20,
        descricao: 'Mandato Sindical - Afastamento temporário para exercício de mandato sindical',
        tipohistorico: '010'
      },
      {
        id: 21,
        descricao: 'Exercício de mandato eleitoral, sem remuneração',
        tipohistorico: '012'
      },
      {
        id: 22,
        descricao: 'Aposentadoria por Invalidez',
        tipohistorico: '014'
      },
      {
        id: 23,
        descricao: 'Gozo de férias ou recesso',
        tipohistorico: '015'
      },
      {
        id: 24,
        descricao: 'Cessão / Requisição',
        tipohistorico: '016'
      },
      {
        id: 25,
        descricao: 'Cárcere',
        tipohistorico: '017'
      },
      {
        id: 26,
        descricao: 'Regime próprio (estatuto), sem remuneração',
        tipohistorico: '035'
      },
      {
        id: 27,
        descricao: 'Acompanhamento de membro da família enfermo',
        tipohistorico: '036'
      },
      {
        id: 28,
        descricao: 'Participar de atividade do Conselho Curador do FGTS - art. 65, §6º, Dec. 99.684/90 (Regulamento do FGTS)',
        tipohistorico: '037'
      },
      {
        id: 29,
        descricao: 'Regime próprio (estatuto), com remuneração',
        tipohistorico: '038'
      },
      {
        id: 30,
        descricao: 'Cargo Eletivo - Candidato a cargo eletivo - Lei 7.664/1988. art. 25°, parágrafo único',
        tipohistorico: '039'
      },
      {
        id: 31,
        descricao: 'Cargo Eletivo - Candidato a cargo eletivo - Lei Complementar 64/1990. art. 1°, inciso II, alínea 1',
        tipohistorico: '040'
      },
      {
        id: 32,
        descricao: 'Exercício de mandato eleitoral, com remuneração',
        tipohistorico: '043'
      },
      {
        id: 33,
        descricao: 'Participação de empregado no Conselho Nacional de Previdência Social-CNPS (art. 3º, Lei 8.213/1991)',
        tipohistorico: '045'
      },
      {
        id: 34,
        descricao: 'Representante Sindical - Pelo tempo que se fizer necessário',
        tipohistorico: '046'
      },
      {
        id: 35,
        descricao: 'Licença Maternidade - de 180 dias, Lei 13.301/2016',
        tipohistorico: '048'
      },
      {
        id: 36,
        descricao: 'Inatividade do trabalhador avulso (portuário ou não portuário) por período superior a 90 dias',
        tipohistorico: '049'
      },
      {
        id: 37,
        descricao: 'Suspensão temporária de contrato nos termos do Plano Emergencial de Manutenção do Emprego e da Renda',
        tipohistorico: '051'
      },
      {
        id: 38,
        descricao: 'Licença por Acordo CCT (Convenção Coletiva de Trabalho)',
        tipohistorico: '053'
      },
      {
        id: 39,
        descricao: 'Qualificação - Afastamento por suspensão do contrato de acordo com o art. 17 da MP 1.116/2022',
        tipohistorico: '055'
      },
      {
        id: 40,
        descricao: 'Qualificação - Afastamento por suspensão do contrato de acordo com o art. 19 da MP 1.116/2022',
        tipohistorico: '056'
      }
    ];

    if (this.entity.trabalhador.sexo === 1) {
      this.motivos.push(
        {
          id: 6,
          descricao: 'Paternidade',
          tipohistorico: '005'
        }
      );
    }
  }

  alteraEntity(): void {
    this.entity.datainicioFormatted = moment(this.entity.datainicio, 'YYYY-MM-DD').format('DD/MM/YYYY');
    this.entity.dataretornoFormatted = moment(this.entity.dataretorno, 'YYYY-MM-DD').format('DD/MM/YYYY');

    if (this.action === 'update') {
      let motivo = this.motivos.filter(motivo => motivo.descricao === this.entity.descricao);
      this.entity.motivo = angular.copy(motivo[0].id!).toString();
      this.entity.trabalhador = angular.copy(this.entity.trabalhadorobj);
    }
  }

  resetDataRetorno(semDataRetornoDefinida: boolean) {
    this.entity.dataretorno = '';
    this.entity.dataretornoFormatted = '';
    this.entity.diasafastamento = semDataRetornoDefinida ? 9999 : 0;
    this.entity.peloinss = this.isAfastadoPeloInss(this.entity.diasafastamento);
  }

  resetDatas() {
    this.entity.datainicio = '';
    this.entity.datainicioFormatted = '';
    this.entity.semdataretorno = true;
    this.resetDataRetorno(this.entity.semdataretorno);
  }

  getMotivo(): void {
    this.motivos.forEach((motivo: any) => {
      if (motivo.id === Number(this.entity.motivo)) {
        this.entity.tipohistorico = motivo.tipohistorico;
        this.entity.descricao = motivo.descricao;
      }
    });

    if (!this.motivoHabilitaCid()) {
      this.entity.cid = null;
      this.entity.medico = null;
    }

    this.setConstructorAfastamentoOrigem();
  }

  isIntervaloDeSessentaDias(dataInicial: moment.Moment, dataFinal: moment.Moment) {
    const intervalo = dataFinal.diff(dataInicial, 'days');
    return intervalo <= 60;
  }

  verificaTipoAfastamento() {
    if (
        this.entity.semdataretorno &&
        this.isMotivoAfastamentoInss()
    ) {
        this.entity.peloinss = true;
        return;
    }
    if (
        this.entity.semdataretorno ||
        !this.valorExiste(this.entity.diasafastamento)
    ) {
        this.entity.peloinss = false;
        return;
    }
    const afastadoPeloInss = this.isAfastadoPeloInss(this.entity.diasafastamento);

    this.entity.peloinss = !afastadoPeloInss && this.entity.afastamentoorigem ?
        this.isAfastadoPorProrrogacaoPeloInss() : afastadoPeloInss;

    this.calculaDataRetorno();
  }

  onChangeDiasAfastamento() {
    this.verificaTipoAfastamento();
    this.buscaAfastamentosColaborador();
  }

  isAfastadoPeloInss(diasAfastamento: number) {
    return (this.isMotivoAfastamentoInss() && diasAfastamento > 15);
  }

  isMotivoAfastamentoInss() {
    const motivos = {
        ACIDENTE_TRABALHO: '001',
        ACIDENTE_TRABALHO_PRORROGADO: '002',
        DOENCA: '003',
        DOENCA_PRORROGADO: '004'
    };
    return (
        this.entity.tipohistorico === motivos.ACIDENTE_TRABALHO ||
        this.entity.tipohistorico === motivos.ACIDENTE_TRABALHO_PRORROGADO ||
        this.entity.tipohistorico === motivos.DOENCA ||
        this.entity.tipohistorico === motivos.DOENCA_PRORROGADO
    );
  }

  isAfastadoPorProrrogacaoPeloInss() {
    if (
        !this.valorExiste(this.entity.afastamentoorigem) ||
        !this.valorExiste(this.entity.datainicio) ||
        !this.valorExiste(this.entity.diasafastamento)
    ) {
        return false;
    }
    const afastamentoPai = this.entity.afastamentoorigem.afastamentotrabalhadorpai ?? null;

    const dataInicioIntervalo = afastamentoPai ?
        moment(afastamentoPai.data) : moment(this.entity.afastamentoorigem.data, 'DD/MM/YYYY');
    const dataFimIntervalo = moment(this.entity.datainicio);
    const intervaloValido = this.isIntervaloDeSessentaDias(dataInicioIntervalo, dataFimIntervalo);
    if (intervaloValido) {
        const totalDeDias =
            this.entity.diasafastamento +
            this.entity.afastamentoorigem.dias +
            (afastamentoPai ? afastamentoPai.dias : 0);
        return this.isAfastadoPeloInss(totalDeDias);
    } else {
        return false;
    }
  }

  calculaDataRetorno() {
    if (
        !this.valorExiste(this.entity.datainicio) ||
        !this.valorExiste(this.entity.diasafastamento)
    ) {
        return;
    }
    this.entity.dataretornoFormatted = moment(this.entity.datainicio).add(this.entity.diasafastamento, 'days').format('DD/MM/YYYY');
    this.entity.dataretorno = moment(this.entity.dataretornoFormatted, 'DD/MM/YYYY').format('YYYY-MM-DD');
  }

  getDataDeInicioMinima() {
    if (!this.valorExiste(this.entity.afastamentoorigem)) {
        return null;
    }
    return moment(this.entity.afastamentoorigem.data, 'DD/MM/YYYY').add(this.entity.afastamentoorigem.dias, 'days').format('YYYY-MM-DD');
  }

  onChangeTrabalhador(trabalhadorSelecionado: any) {
    this.entity.motivo = '';
    this.entity.descricao = '';
    this.entity.tipohistorico = '';
    this.entity.cid = null;
    this.entity.medico = null;
    this.resetDatas();

    if (trabalhadorSelecionado) {
      this.montaMotivos();
    } else {
      this.motivos = [];
    }
  }

  setConstructorAfastamentoOrigem() {
    const constructor = {
      trabalhador: this.action === 'retrieve' ? this.entity.trabalhador : this.entity.trabalhador.trabalhador,
      estado: 1,
      _tipoHistorico: this.entity.tipohistorico ? this.entity.tipohistorico : null,
      _apenasComDataRetorno: true
    };
    this.PersonaAfastamentos.entitiesFirstLoad = [];
    this.constructorAfastamentoOrigem = constructor;
  }

  motivoHabilitaAfastamentoOrigem() {

    let habilitaAfastamentoOrigem: boolean = false;

    habilitaAfastamentoOrigem = this.motivosHabilitamAfastamentoOrigem.some((objMotivo: IAfastamentoMotivo) => {
      return objMotivo.tipohistorico === this.entity.tipohistorico;
    });

    if (!habilitaAfastamentoOrigem && this.action !== 'retrieve') {
      this.entity.afastamentoorigem = null;
    }

    return habilitaAfastamentoOrigem;

  }

  motivoHabilitaCid() {
    return this.motivosHabilitamCid.includes(this.entity.tipohistorico);
  }

  /**
   * Buscando os afastamentos do colaborador selecionado para verificar se há sobreposição das datas selecionadas com as datas de algum afastamento existente
   */
  buscaAfastamentosColaborador() {

    if (this.entity.trabalhador && this.entity.datainicio && this.entity.dataretorno && this.entity.diasafastamento) {
        const dataFimValidacao = this.getDataFimValidacao(this.entity.dataretorno as string);

        this.busy = true;

        this.MeurhAfastamentosService.loadNoPagination({
            datainicio: this.entity.datainicio as string,
            datafim: dataFimValidacao,
            empresa: this.entity.trabalhador.empresaobj.empresa as string,
            trabalhador: this.entity.trabalhador.trabalhador as string,
        }).then((response: any) => {
            const afastamentosLista = Object.values(response);
            if (afastamentosLista && afastamentosLista.length) {
                this.NewToaster.pop({
                    type: 'warning',
                    title: 'Solicitação já enviada',
                    body: 'Já existe um afastamento para este colaborador dentro das datas enviadas'
                });
                this.form.datasSobrepostas = true;
                return Promise.reject('PARAR');
            }
            return this.MeurhAfastamentosService._load({trabalhador: this.entity.trabalhador.trabalhador}, {}, '');
        }).then((retorno: any) => {
            // se houver algum afastamento com a situação -1 (rascunho), 0 (enviado), verificar se há datas sobrepostas com as selecionadas
            const afastamentosParaVerificar = retorno.filter(afastamentoExistente => {
                return afastamentoExistente.situacao < 1;
            });

            if (afastamentosParaVerificar && afastamentosParaVerificar.length) {
                let datasSobrepostas: boolean = false;

                // verificando se há algum afastamento com sobreposição de datas com as datas selecionadas
                datasSobrepostas = afastamentosParaVerificar.some((afastamentoEnviado) => {
                    return this.temSobreposicaoDatasAfastamentos(
                    this.entity.datainicio as string,
                    dataFimValidacao,
                    afastamentoEnviado.datainicio,
                    this.getDataFimValidacao(afastamentoEnviado.dataretorno)
                    );
                });

                if (datasSobrepostas) {
                    this.NewToaster.pop({
                    type: 'warning',
                    title: 'Solicitação já enviada',
                    body: 'Já existe uma solicitação de afastamento para este colaborador dentro das datas enviadas'
                    });
                    // usado para controlar botão de salvar/enviar afastamento na criação/edição de afastamento
                    this.form.datasSobrepostas = true;
                } else {
                    this.form.datasSobrepostas = false;
                }
            } else {
                this.form.datasSobrepostas = false;
            }
        })
        .catch((err: unknown) => {
            if (err !== 'PARAR') {
                console.error(err);
            }
        })
        .finally(() => {
            this.busy = false;
        });

    } else {
      this.form.datasSobrepostas = false;
    }
  }

  /**
   * Recebe a data de início e a data final efetiva do afastamento a ser criado/editado
   * e as datas de início e final efetiva do afastamento a ser testado.
   * Retorna booleano informando se há sobreposição de datas
   * @param dataInicioSelecionada o campo 'iniciando em' no afastamento da tela
   * @param dataFimSelecionada a data final efetiva do afastamento da tela
   * @param dataInicioAfastamentoExistente a data de início do afastamento testado
   * @param dataFimAfastamentoExistente a data final efetiva do afastamento testado
   * @returns booleano informando se há sobreposição de datas
   */
  temSobreposicaoDatasAfastamentos(
    dataInicioSelecionada: string,
    dataFimSelecionada: string,
    dataInicioAfastamentoExistente: string,
    dataFimAfastamentoExistente: string
  ) {

    // datas no formato moment para fazer comparações
    const dataInicioSelecionadaMoment = moment(dataInicioSelecionada, 'YYYY-MM-DD');
    const dataFimSelecionadaMoment = moment(dataFimSelecionada, 'YYYY-MM-DD');
    const dataInicioAfastamentoExistenteMoment = moment(dataInicioAfastamentoExistente, 'YYYY-MM-DD');
    const dataFimAfastamentoExistenteMoment = moment(dataFimAfastamentoExistente, 'YYYY-MM-DD');

    // último parâmetro função isBetween: () = exclui a data inicial ou final; [] = inclui a data inicial ou final
    const condicao1 = dataInicioSelecionadaMoment.isBetween(dataInicioAfastamentoExistenteMoment, dataFimAfastamentoExistenteMoment, undefined, '[]');
    const condicao2 = dataFimSelecionadaMoment.isBetween(dataInicioAfastamentoExistenteMoment, dataFimAfastamentoExistenteMoment, undefined, '[]');
    const condicao3 = dataInicioAfastamentoExistenteMoment.isBetween(dataInicioSelecionadaMoment, dataFimSelecionadaMoment, undefined, '[]');
    const condicao4 = dataFimAfastamentoExistenteMoment.isBetween(dataInicioSelecionadaMoment, dataFimSelecionadaMoment, undefined, '[]');

    // retorna true se qualquer uma das condições for verdadeira
    return condicao1 || condicao2 || condicao3 || condicao4;
  }

  getDataFimValidacao(dataRetorno: string) {
    if (!this.valorExiste(dataRetorno)) {
      return '';
    }
    return moment(dataRetorno, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD');
  }

    valorExiste(valor: any) {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
